const state = () => (localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {
  userInfo: {},
})


const mutations = {
  setUserInfo (state, userInfo) {
    state.userInfo = userInfo
  },
  deleteAllUserInfo (state) {
    state.userInfo = {}
  },
}

export default {
  namespaced: true,
  state,
  mutations
}